module.exports = __webpack_public_path__ + "img/IMG_1198.897b28da.png";